<div class="uploading-spinner"></div>
